import { z } from 'zod';

/**
 * Loose shape-identification schemas for pre-versioning blocks. Only the legacy `type`
 * discriminator is required: the up() transforms are defensive (asRecord/toNumber) and
 * the v0 validation after migration catches real corruption. NOTE: at the structure
 * adapter, `sections` arrives denormalized (section objects, not ids).
 */
export const blockDefaultLegacySchema = z.looseObject({
    // Optional: the oldest blocks predate the tag entirely.
    type: z.literal('DEFAULT').optional(),
    id: z.unknown().optional(),
    sections: z.array(z.unknown()).optional(),
    styles: z.unknown().optional(),
    data: z.unknown().optional(),
    mobileStyles: z.unknown().optional(),
    mobileData: z.unknown().optional(),
    displayId: z.unknown().optional(),
});

export const blockSpecificLegacySchema = z.looseObject({
    type: z.literal('specific'),
    id: z.unknown().optional(),
    sections: z.array(z.unknown()).optional(),
    styles: z.unknown().optional(),
    data: z.unknown().optional(),
    mobileStyles: z.unknown().optional(),
    mobileData: z.unknown().optional(),
    isShared: z.unknown().optional(),
    sharedBlockProps: z.unknown().optional(),
    displayId: z.unknown().optional(),
});

export const blockZeroLegacySchema = z.looseObject({
    type: z.literal('zero'),
    id: z.unknown().optional(),
    sections: z.array(z.unknown()).optional(),
    styles: z.unknown().optional(),
    data: z.unknown().optional(),
    mobileStyles: z.unknown().optional(),
    mobileData: z.unknown().optional(),
    displayId: z.unknown().optional(),
});
